<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<template>
  <v-row class="grey lighten-4 tile mt-12" dense>
    <v-col cols="12" class="fill-height d-flex flex-column">
      <v-card flat tile color="transparent">
        <v-card-title class="justify-center pb-12">
          <h3 class="text-center wordBreak">
            {{ $t('component.dashboard.tailTile.title') }}
          </h3>
        </v-card-title>
        <v-card-text class="text-center wordBreak">
          <p v-html="$t('component.dashboard.tailTile.content.top')" />
          <p v-html="$t('component.dashboard.tailTile.content.bottom')" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
